/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roman → Number`)
};

const es_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romano → Número`)
};

const de_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Römisch → Zahl`)
};

const nl_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romeins → Getal`)
};

const fr_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romain → Nombre`)
};

const it_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romano → Numero`)
};

const pt_br2_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romano → Número`)
};

const pt_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romano → Número`)
};

const ja_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローマ数字 → 数字`)
};

const zh_rn_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roman → Number`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_mode_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_mode_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_mode_decode", locale)
	if (locale === "en") return en_rn_mode_decode(inputs)
	if (locale === "es") return es_rn_mode_decode(inputs)
	if (locale === "de") return de_rn_mode_decode(inputs)
	if (locale === "nl") return nl_rn_mode_decode(inputs)
	if (locale === "fr") return fr_rn_mode_decode(inputs)
	if (locale === "it") return it_rn_mode_decode(inputs)
	if (locale === "pt-BR") return pt_br2_rn_mode_decode(inputs)
	if (locale === "pt") return pt_rn_mode_decode(inputs)
	if (locale === "ja") return ja_rn_mode_decode(inputs)
	return zh_rn_mode_decode(inputs)
};